import { REQUEST_ARTICLE_OG } from './types';

export function fetchArticleOpenGraph(url) {
  return {
    type: REQUEST_ARTICLE_OG,
    url
  };
}



// WEBPACK FOOTER //
// ./src/actions/articles.js